"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useLangContext_1 = require("../../../../hooks/useLangContext");
const Text_1 = __importDefault(require("../../../_core/Text"));
const TableRow_1 = __importDefault(require("../TableRow"));
const utils_1 = require("../TableRow/utils");
const locales_1 = __importDefault(require("./locales"));
const TableHeader = () => {
    const { syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.default);
    return (react_1.default.createElement(TableRow_1.default, { bg: "grey.300" },
        react_1.default.createElement(TableRow_1.default.ColumnDetails, null,
            react_1.default.createElement(Text_1.default, { fontWeight: "weight-500" }, locales_1.default[utils_1.ColumnName.Details])),
        react_1.default.createElement(TableRow_1.default.ColumnUnits, null,
            react_1.default.createElement(Text_1.default, { fontWeight: "weight-500" }, locales_1.default[utils_1.ColumnName.Units])),
        react_1.default.createElement(TableRow_1.default.ColumnUnitPrice, null,
            react_1.default.createElement(Text_1.default, { fontWeight: "weight-500" }, locales_1.default[utils_1.ColumnName.UnitPrice])),
        react_1.default.createElement(TableRow_1.default.ColumnVatPercentage, null,
            react_1.default.createElement(Text_1.default, { fontWeight: "weight-500" }, locales_1.default[utils_1.ColumnName.VatPercentage])),
        react_1.default.createElement(TableRow_1.default.ColumnTotalWithoutTaxes, null,
            react_1.default.createElement(Text_1.default, { fontWeight: "weight-500" }, locales_1.default[utils_1.ColumnName.TotalWithoutTaxes]))));
};
exports.default = TableHeader;
